import Coords from './Coords'
class ScrollReveal
{
    /**
     * Constructor
     */
    constructor( options )
    {
        this.animateEl = document.querySelectorAll('.to-animate')
        this.offset = 0
        this.el = []
        this.coords = new Coords
    }

    animate() {
        this.offset = window.scrollY

        this.el.forEach(element => {
            // console.log('element.offset < this.offset', element.offset , this.offset)
            if(element.offset < this.offset && !element.el.classList.contains('animation')) {
                element.el.classList.add('animation')
            }
        })
    }

    scrollEvent() {
        window.addEventListener('scroll', (e) => {
            this.animate()
        }, {passive: true})
    }

    checkInitScroll() {
        this.animate()
    }

    setObj() {
        this.animateEl.forEach(element => {
            let offsetDelay
            if(element.getAttribute('data-delay')) {
                if(element.getAttribute('data-delay') === 'mid') {
                    const body = document.querySelector('body')
                    if(body.classList.contains('isMobile')) {
                        offsetDelay = element.getBoundingClientRect().height * 1.3
                    } else {
                        offsetDelay = element.getBoundingClientRect().height / 2
                    }
                } else if(element.getAttribute('data-delay') === 'midTop') {
                    offsetDelay = element.getBoundingClientRect().height
                } else if(element.getAttribute('data-delay') === 'midBottom') {
                    offsetDelay = element.getBoundingClientRect().height * 1.5
                }  else if(element.getAttribute('data-delay') === 'bottom') {
                    offsetDelay = window.innerHeight / 1.5
                } else {
                    offsetDelay = parseInt(element.getAttribute('data-delay'))
                }
            } else {
                offsetDelay = 0
            }
            let obj = {
                el: element,
                // offset: element.offsetTop,
                offset: this.coords.init(element).top - offsetDelay,
                animate: false
            }
            if(element.classList.contains('numberCounter')) {
                obj = {
                    el: element,
                    // offset: element.offsetTop,
                    offset: this.coords.init(element.parentNode.parentNode).top - offsetDelay,
                    animate: false
                }
            }
            this.el.push(obj)
        })

        this.checkInitScroll()
    }

    init() {
        if(document.querySelector('.to-animate')) {
            this.scrollEvent()
            this.setObj()
        }
    }
}

export default ScrollReveal
